import { useAuth } from "@/context/AuthContext";
import { TabNavProvider } from "@/context/TabNavContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import QuoteToast from "@/components/QuoteToast";
import MemberView from "@/pages/MemberView";
import ManagerView from "@/pages/ManagerView";
import ForcePasswordChange from "@/pages/ForcePasswordChange";

export default function Dashboard() {
  const { user } = useAuth();
  if (user.must_change_password) return <ForcePasswordChange />;
  const isWriter = user.role === "user" && !user.is_lead;
  const canManageTeam = user.is_owner;
  const roleLabel = user.is_owner
    ? "Owner console"
    : user.is_lead
    ? "Team console"
    : user.role === "user"
    ? "My workspace"
    : "Manager console";
  return (
    <TabNavProvider>
      <div className="min-h-screen bg-background flex flex-col">
        <Navbar subtitle={roleLabel} />
        <main className="flex-1 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
          {isWriter ? <MemberView /> : <ManagerView canManageTeam={canManageTeam} isOwner={user.is_owner} />}
        </main>
        <Footer />
      </div>
      <QuoteToast />
    </TabNavProvider>
  );
}
